import { render, staticRenderFns } from "./StripePriceSync.vue?vue&type=template&id=06d74a8e&scoped=true"
import script from "./StripePriceSync.vue?vue&type=script&lang=js"
export * from "./StripePriceSync.vue?vue&type=script&lang=js"
import style0 from "./StripePriceSync.vue?vue&type=style&index=0&id=06d74a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d74a8e",
  null
  
)

export default component.exports